import { render, staticRenderFns } from "./SetupArea.vue?vue&type=template&id=26be0b91&"
import script from "./SetupArea.vue?vue&type=script&lang=js&"
export * from "./SetupArea.vue?vue&type=script&lang=js&"
import style0 from "./SetupArea.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports